import {LazyLoad} from './LazyLoad';

new LazyLoad().run();
